export const CONSTANTES = {
    BLOQUE_BIENVENIDA: 'bloqueBienvenida',
    BLOQUE_QUIENES_SOMOS: 'bloqueQuienesSomos',
    LOGO_DISEÑO_LINEAS_NEGRAS: '../../../../../assets/images/header/Diseño_lineas_negro.png',
    LOGO_BLANCO: '../../../../../assets/images/logo-blanco.png',
    CAMPO_OBLIGATORIO: 'Campo obligatorio.',
    URL_PRODUCCION: 'https://olas-verdes-back.onrender.com'
    //  'https://olas-verdes-back.onrender.com'
};